import React, { Component, ReactNode } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import LoginForm from '../components/loginForm'
import { DuoIframe } from '../components/duoIframe'
import { submitLogin, submitDuoLogin } from '../actions/sessionActions'

import queryString from 'query-string'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  isAuth: boolean
  location: Location
  showDuo: boolean
  sigRequest: string
  submitDuoLogin: Callback
  submitLogin: Callback
}

export class LoginView extends Component<Props> {
  static displayName = 'Login'

  render() {
    const {
      location,
      isAuth,
      showDuo,
      sigRequest,
      submitDuoLogin,
      submitLogin,
    } = this.props

    if (isAuth) {
      const redirect = queryString.parse(location.search).return_to || '/'
      return <Redirect to={redirect} />
    }

    let content: ReactNode = null

    if (showDuo) {
      content = <DuoIframe sigRequest={sigRequest} duoLogin={submitDuoLogin} />
    } else {
      content = <LoginForm onSubmit={submitLogin} />
    }

    return (
      <div className="row center-xs">
        <div className="col-xs-4 login" data-test="login-container">
          {content}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    submitLogin: (values) => dispatch(submitLogin(values)),
    submitDuoLogin: (action, sigResponse) =>
      dispatch(submitDuoLogin(action, sigResponse)),
  }
}

const mapStateToProps = (store) => {
  const { isAuth, showDuo, sigRequest } = store.session

  return {
    isAuth,
    showDuo,
    sigRequest,
  }
}

export const Login = connect(mapStateToProps, mapDispatchToProps)(LoginView)
